// @ts-nocheck
/**
 * Algolia Enhanced Predictive Search
 * 
 * This script enhances the existing predictive search with Algolia Autocomplete
 * while maintaining compatibility with the current implementation.
 */

(function() {
  'use strict';

  // Wait for Algolia libraries to load
  function waitForAlgolia() {
    return new Promise((resolve) => {
      // @ts-ignore
      if (window.algoliasearch && window['@algolia/autocomplete-js'] && window['@algolia/autocomplete-plugin-query-suggestions']) {
        // @ts-ignore
        resolve();
      } else {
        const checkInterval = setInterval(() => {
          // @ts-ignore
          if (window.algoliasearch && window['@algolia/autocomplete-js'] && window['@algolia/autocomplete-plugin-query-suggestions']) {
            clearInterval(checkInterval);
            // @ts-ignore
            resolve();
          }
        }, 100);
      }
    });
  }

  // Get Algolia configuration from global config
  /**
   * Global function to render product items for Algolia autocomplete
   * @param {Object} params - Parameters object
   * @param {Function} params.html - HTML template function
   * @param {Object} params.hit - Product item data
   * @param {Object} params.components - Algolia components (Highlight, etc.)
   * @returns {string} Rendered HTML
   */
  // @ts-ignore
  function RenderProductItem({ html, hit, components }) {
    // Format price similar to Shopify's money filter
    // @ts-ignore
    const formatPrice = (price) => {
      if (!price) return '';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(price / 100);
    };
    // Check if product is on sale
    // @ts-ignore
    const isOnSale = hit.compare_at_price && hit.compare_at_price > hit.price;
    // @ts-ignore
    const regularPrice = hit.compare_at_price || hit.price;
    // @ts-ignore
    const salePrice = hit.price;

    // Extract properties to avoid TypeScript issues in template
    // @ts-ignore
    let productUrl = `/products/${hit.handle}`;
    // @ts-ignore
    const productTitle = hit.title;
    // @ts-ignore
    const productImage = hit.image;
    // @ts-ignore
    const highlightComponent = components.Highlight;

    return html`
        <div class="resource-card" data-resource-type="product">
          <a class="resource-card__link" href="${productUrl}">
            <span class="visually-hidden">${productTitle}</span>
          </a>
          <div class="resource-card__media" style="--resource-card-aspect-ratio: 4 / 5;">
            ${productImage ? html`
              <img
                src="${productImage}"
                alt="${productTitle}"
                class="resource-card__image"
                loading="lazy"
                width="500"
                height="625"
              />
            ` : html`
              <div class="resource-card__image-placeholder" aria-hidden="true">
                ${productTitle}
              </div>
            `}
          </div>
          <div class="resource-card__content">
            <p class="resource-card__title paragraph">
              ${highlightComponent({
                hit: hit,
                attribute: "title",
              })}
            </p>
            <div class="price">
              ${isOnSale ? html`
                <span role="group">
                  <span class="visually-hidden">Regular price </span>
                  <span class="compare-at-price">${formatPrice(regularPrice)}</span>
                </span>
                <span role="group">
                  <span class="visually-hidden">Sale price </span>
                  <span class="price">${formatPrice(salePrice)}</span>
                </span>
              ` : html`
                <span class="price">${formatPrice(salePrice)}</span>
              `}
            </div>
          </div>
        </div>
    `;
  }

  // @ts-ignore 
  function debouncePromise(fn, time) {
    let timer = undefined;

    return function debounced(...args) {
      if (timer) {
        clearTimeout(timer); // Clear the timeout first if it's already defined.
      }

      return new Promise((resolve) => {
        timer = setTimeout(() => resolve(fn(...args)), time);
      });
    };
  }

  /**
   * Default order of product handles for sorting
   * Products will be sorted by their index in this array
   * Products not in this array will be moved to the end
   * Can be overridden via dataset.defaultOrder
   */
  const DEFAULT_ORDER = [
    'hi-fibre-lo-gi-white-block-loaf',
    'hi-fibre-lo-gi-round-roll',
    'mini-cheese-bacon-rolls-6-pack',
    'cheesymite-scroll',
    'sticky-cinnamon-scroll',
  ];


  function sortProducts(...rawSources) {
    const sources = rawSources.flat().filter(Boolean);
    // @ts-ignore
    const maxItems = (typeof ALGOLIA_CONFIG !== 'undefined' && ALGOLIA_CONFIG.maxProductSuggestions) || 0;

    return sources.map((source) => {
      const sorted = source.getItems().slice().sort((a, b) => {
        const indexA = DEFAULT_ORDER.indexOf(a.handle);
        const indexB = DEFAULT_ORDER.indexOf(b.handle);

        // Items not in the defaultOrder appear last, in original order
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });

      // The Algolia products index holds one record per product variant, so a
      // multi-variant product returns several hits that share the same handle.
      // Collapse to the first hit per handle so each product appears once.
      const seenHandles = new Set();
      const deduped = sorted.filter((item) => {
        const key = item.handle || item.objectID;
        if (seenHandles.has(key)) return false;
        seenHandles.add(key);
        return true;
      });

      // getItems over-fetches (see hitsPerPage) so de-duplication doesn't
      // starve the list; trim back to the configured suggestion count.
      const items = maxItems > 0 ? deduped.slice(0, maxItems) : deduped;

      return {
        ...source,
        getItems() {
          return items;
        },
      };
    });
  }
  /**
   * Enhanced Predictive Search Component with Algolia Integration
   */
  class AlgoliaPredictiveSearch {
    constructor() {
      // @ts-ignore
      this.autocompleteInstance = null;
      this.searchClient = null;
      this.isInitialized = false;
      this.popularCollection = null;
      this.defaultOrder = [];
    }

    /**
     * Initialize Algolia Autocomplete
     */
    async initialize(dataset) {
      console.log('Initializing Algolia Predictive Search');
      if (this.isInitialized) return;
      try {
        await waitForAlgolia();
        // @ts-ignore
        const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
        // @ts-ignore
        const algoliasearch = window.algoliasearch;
        // @ts-ignore
        const { createQuerySuggestionsPlugin } = window['@algolia/autocomplete-plugin-query-suggestions'];
        
        // Create search client
        const searchClient = algoliasearch(ALGOLIA_CONFIG.appId, ALGOLIA_CONFIG.apiKey);
        this.searchClient = searchClient;
        // Store popular collection ID from dataset
        this.popularCollection = dataset.popularCollection || null;
        // Initialize default order from constant or dataset
        this.defaultOrder = [...DEFAULT_ORDER];
        // Find the search container - prioritize drawer, fallback to modal
        const searchContainer = document.querySelector('.algolia-search-drawer__search-form .algolia-predictive-search-form__content') || 
                                document.querySelector('.algolia-predictive-search-form__content');
        
        // Get configuration from global ALGOLIA_CONFIG
        const maxSuggestions = ALGOLIA_CONFIG.maxPopularKeywordsSuggestions;
        const maxProductSuggestions = ALGOLIA_CONFIG.maxProductSuggestions;
        const plugins = [];
        if (maxSuggestions > 0) {
          const querySuggestionsPlugin = createQuerySuggestionsPlugin({
            searchClient: searchClient,
            // @ts-ignore
            indexName: ALGOLIA_CONFIG.querySuggestionsIndexName,
            getSearchParams() {
              return {
                hitsPerPage: maxSuggestions,
              };
            },
            transformSource({ source }) {
              function createUrl(item) {
                const urlParams = new URLSearchParams();
                urlParams.set("q", item.query);
                return `/search?${urlParams.toString()}`;
              }
          
              return {
                ...source,
                getItemUrl({ item }) {
                  return createUrl(item);
                },
                templates: {
                  item(params) {
                    const { item, html } = params;
          
                    return html`<a class="aa-ItemLink" href="${createUrl(item)}">
                      ${source.templates.item(params).props.children}
                    </a>`;
                  },
                },
              };
            },
          });
          plugins.push(querySuggestionsPlugin);
        }
        const debounced = debouncePromise(
          (items) => Promise.resolve(items),
          +dataset.debounceTime,
        );
        
        if (!searchContainer ) {
          console.warn('Algolia Predictive Search: Required elements not found');
          return;
        }
        const stallThreshold = +dataset.debounceTime + 300;
        // Capture popularCollection and defaultOrder for use in getSources
        const popularCollection = this.popularCollection;
        const defaultOrder = this.defaultOrder;
        this.autocompleteInstance = autocomplete({
          container: searchContainer,
          placeholder: ALGOLIA_CONFIG.placeholder,
          openOnFocus: true,
          plugins: plugins,
          detachedMediaQuery: 'none',
          autoFocus: dataset.openOnFocus && dataset.openOnFocus.toLowerCase() !== 'false',
          insights: dataset.enableInsights,
          onSubmit({ state }) {
            window.location.href = `/search?q=${state.query}`;
          },
          // @ts-ignore
          reshape({  sourcesBySourceId }) {

            const { products, ...rest } = sourcesBySourceId;
            
            return [
              sortProducts(products), // modify only product
              ...Object.values(rest),        // include other sources unchanged
            ];
          },
          // @ts-ignore
          getSources({ query, state }) {
            return debounced([
              {
                sourceId: 'products',
                getItems() {
                  // Check if query is empty and popular collection is set
                  const isEmptyQuery = !query || query.trim() === '';
                  const shouldFilterByCollection = isEmptyQuery && popularCollection;
                  
                  // Build search params. The products index stores one record
                  // per variant, so we over-fetch (capped at 50) and de-dupe by
                  // handle in `sortProducts` before trimming back to
                  // `maxProductSuggestions` — otherwise a single multi-variant
                  // product could fill the entire suggestion list.
                  const searchParams = {
                    hitsPerPage: Math.min(Math.max(maxProductSuggestions * 10, maxProductSuggestions), 50),
                    highlightPreTag: ALGOLIA_CONFIG.highlightPreTag,
                    highlightPostTag: ALGOLIA_CONFIG.highlightPostTag,
                  };
                  
                  // Add collection filter if query is empty and popular collection is set
                  if (shouldFilterByCollection) {
                    // Filter by collection ID - adjust the field name based on your Algolia index structure
                    // Common field names: collections, collections.id, product_collections, etc.
                    searchParams.filters = `collections:${popularCollection}`;
                  }
                  
                  return getAlgoliaResults({
                    // @ts-ignore
                    searchClient: searchClient,
                    queries: [{
                      indexName: ALGOLIA_CONFIG.productsSearchIndexName,
                      query: query || '', // Use empty string if query is null/undefined
                      params: searchParams,
                    }],
                  });
                },
                templates: {
                  // @ts-ignore
                  item({ html, item, components }) {
                    return RenderProductItem({ html, hit: item, components });
                  },
                  // @ts-ignore
                  noResults({html}) {
                    return html`
                      <div class="algolia-no-results">
                        <div class="algolia-no-results-title">${ALGOLIA_CONFIG.noResultsText}</div>
                      </div>
                    `;
                  },
                  // @ts-ignore
                  footer({html, items, state}) {
                    if (items.length > 0) {
                      // Use state.query to get current search query (behave like Enter key)
                      const searchQuery = state?.query || '';
                      const footerUrl = searchQuery.trim() !== ''
                        ? `/search?q=${encodeURIComponent(searchQuery)}`
                        : dataset.emptySearchUrl;
                      
                      return html`
                        <div class="aa-Footer">
                          <a href="${footerUrl}" class="aa-Footer__link">
                            <span class="aa-Footer__text">${ALGOLIA_CONFIG.viewAllProductsText}</span>
                            <svg class="aa-Footer__icon" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.66699 9.99996H16.3337M16.3337 9.99996L10.5003 4.16663M16.3337 9.99996L10.5003 15.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                          </a>
                        </div>
                      `;
                    }
                    return html``;
                  },
                },
              },
            ]);
          },
          // @ts-ignore
          render({ elements, render, html }, root) {
            // Prioritize search drawer, fallback to modal
            const resultsContainer = document.querySelector('.algolia-predictive-search-results__wrapper-products') ;
            if (resultsContainer) {
              if (maxSuggestions > 0) {
                render(
                  html`
                  <div class="algolia-predictive-search-popular-searches">
                    ${html`${elements.querySuggestionsPlugin}`}
                  </div>
                    ${html`${elements.products}`}
                  `,
                  resultsContainer  
                );
              } else {
                render(html`${elements.products}`, resultsContainer);
              }
            }
          },
        });
        this.isInitialized = true;
        console.log('Algolia Predictive Search initialized successfully');

      } catch (error) {
        console.error('Failed to initialize Algolia Predictive Search:', error);
      }
    }

    /**
     * Destroy the autocomplete instance
     */
    destroy() {
      if (this.autocompleteInstance) {
        this.autocompleteInstance.destroy();
        this.autocompleteInstance = null;
      }
      this.isInitialized = false;
    }
  }

  // Create global instance
  const algoliaPredictiveSearch = new AlgoliaPredictiveSearch();

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    // Check if Algolia is enabled and properly configured
    // @ts-ignore
    if (typeof window.isAlgoliaEnabled === 'function' && !window.isAlgoliaEnabled()) {
      console.log('Algolia search is disabled in theme settings');
      return;
    }
    
    // Only initialize if we're in a context where search is available
    if (document.querySelector('.predictive-search-form__content') || document.querySelector('.algolia-search-drawer')) {
      const searchButton = document.querySelector('search-button');
      if (searchButton) {
        algoliaPredictiveSearch.initialize(searchButton.dataset);
      }
    }
    
    // Add event listener for clear button to close autocomplete and modal/drawer
    setupClearButtonHandler();
  });

  /**
   * Setup event listener for the clear button to close autocomplete and modal
   */
  function setupClearButtonHandler() {
    // Use event delegation to handle dynamically created clear buttons
    document.addEventListener('click', (event) => {
      // @ts-ignore
      const clearButton = event.target?.closest('.aa-ClearButton');
      
      if (clearButton) {
        event.preventDefault();
        
        // Close the autocomplete
        if (algoliaPredictiveSearch.autocompleteInstance) {
          algoliaPredictiveSearch.autocompleteInstance.setQuery('');
          algoliaPredictiveSearch.autocompleteInstance.setIsOpen(false);
        }
        
        // Close the search drawer or modal dialog
        const searchDrawer = document.querySelector('algolia-search-drawer-component');
        const searchModal = document.getElementById('search-modal');
        
        if (searchDrawer) {
          // Close the search drawer
          // @ts-ignore
          if (searchDrawer.close && typeof searchDrawer.close === 'function') {
            // @ts-ignore
            searchDrawer.close();
          }
        } else if (searchModal) {
          // Fallback to modal
          // @ts-ignore
          if (searchModal.closeDialog && typeof searchModal.closeDialog === 'function') {
            // @ts-ignore
            searchModal.closeDialog();
          } else {
            // Fallback for native dialog
            const dialog = searchModal.querySelector('dialog');
            if (dialog && dialog.close) {
              dialog.close();
            }
          }
        }
      }
    });
  }

  // Export for potential use by other modules
  // @ts-ignore
  if (typeof window !== 'undefined' && !window.algoliaPredictiveSearch) {
    window.algoliaPredictiveSearch = algoliaPredictiveSearch;
  }
})();
